module.exports = __webpack_public_path__ + "media/newstyle/images/icon-googleplay-f0cfccf4a5119d5446fef67b758905ed.svg";